<div class="books">
  <div class="card">
    <h3 class="card-header text-center font-weight-bold text-uppercase py-4">
      ALl Users
    </h3>
    <div class="card-body">
      <div id="table" class="table-editable">
        <table
          class="table table-bordered table-responsive-md table-striped text-center"
        >
          <thead>
            <tr>
              <th class="text-center">User Email</th>
              <th class="text-center">User Name</th>
              <th class="text-center">edit</th>
              <th class="text-center">Remove</th>
            </tr>
          </thead>
          <tbody *ngFor="let User of Users">
            <tr>
              <td class="pt-3-half">{{ User.email }}</td>
              <td class="pt-3-half">{{ User.fullName }}</td>

              <td class="pt-3-half">
                <span class="table-up"
                  ><a
                    (click)="frame.show()"
                    mdbWavesEffect
                    data-toggle="modal"
                    data-target="#basicExample"
                    class="indigo-text"
                    ><i class="fas fa-pen" aria-hidden="true"></i></a
                ></span>
              </td>
              <td>
                <span class="table-remove"
                  ><button
                    type="button"
                    class="btn btn-danger btn-rounded btn-sm my-0"
                    (click)="remove(User.id)"
                  >
                    Remove
                  </button></span
                >
              </td>
            </tr>
            <div
              mdbModal
              #frame="mdbModal"
              class="modal fade"
              id="frameModalTop"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              aria-hidden="true"
              (open)="onOpen(User.id)"
            >
              <div
                class="modal-dialog modal-notify modal-success"
                role="document"
              >
                <!--Content-->
                <div class="modal-content">
                  <!--Header-->
                  <div class="modal-header">
                    <p class="heading lead">edit book</p>

                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      (click)="frame.hide()"
                    >
                      <span aria-hidden="true" class="white-text">&times;</span>
                    </button>
                  </div>

                  <!--Body-->
                  <div class="modal-body">
                    <div class="text-center">
                      <form #form="ngForm">
                        <input
                          type="text"
                          name="title"
                          [(ngModel)]="id"
                          class="form-control"
                        />
                        <input
                          type="text"
                          name="description"
                          [(ngModel)]="email"
                          class="form-control"
                        />
                        <input
                          type="text"
                          name="image"
                          [(ngModel)]="firstName"
                          class="form-control"
                        />
                        <input
                          type="text"
                          name="rate"
                          [(ngModel)]="lastName"
                          class="form-control"
                        />
                      </form>
                    </div>
                  </div>

                  <!--Footer-->
                  <div class="modal-footer justify-content-center">
                    <a
                      type="button"
                      mdbBtn
                      color="primary"
                      class="waves-light"
                      mdbWavesEffect
                      (click)="done(User.id); frame.hide()"
                    >
                      save changes
                      <mdb-icon fas icon="check" class="ml-1"></mdb-icon>
                    </a>
                    <a
                      type="button"
                      mdbBtn
                      color="primary"
                      outline="true"
                      class="waves-effect"
                      mdbWavesEffect
                      (click)="frame.hide()"
                      data-dismiss="modal"
                      >cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
